import React from 'react';

import CurrentVersionReadOnlyReasonWrapper from 'app/developer-v3/components/CurrentVersionReadOnlyReasonWrapper';

import AuthenticationEditor from './AuthenticationEditor';

export default function AuthenticationEditorWrapper(props) {
  return (
    <CurrentVersionReadOnlyReasonWrapper
      Component={AuthenticationEditor}
      {...props}
    />
  );
}
